<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
//  import VConsole from 'vconsole';
  export default {
    name: 'App',
    data() {
      return {

      }
    },
    created() {
//      const vConsole = new VConsole();
      // 或者使用配置参数来初始化，详情见文档
      //const vConsole = new VConsole({ maxLogNumber: 1000 });

      // 接下来即可照常使用 `console` 等方法
      //console.log('Hello world');
    }
  }
</script>
<!--<script src="https://unpkg.com/vconsole@latest/dist/vconsole.min.js"></script>
<script>
// VConsole 默认会挂载到 `window.VConsole` 上
  var vConsole = new window.VConsole();
</script>-->

<style>
    #app {
        font-size: 0;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background-color: #ffffff;
        padding: 0 0 0.2rem;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue